/**
 * Safe rendering helpers for Leaflet center labels.
 *
 * Boundary labels may be persisted in GeoJSON. Escape content before using
 * Leaflet's HTML-string divIcon API, then use DOM text nodes for live updates.
 */
export const CENTER_LABEL_ICON_CLASS = "crs-map-center-label-icon";
export function escapeMapLabel(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function formatMapAreaLabel(areaSqM: number): string {
  return Number.isFinite(areaSqM) && areaSqM > 0
    ? `${Math.round(areaSqM).toLocaleString("en-US")} m²`
    : "";
}

export function buildCenterLabelHtml(label: unknown, areaSqM: number): string {
  const safeLabel = escapeMapLabel(label);
  const areaText = formatMapAreaLabel(areaSqM);
  return `<div style="background:rgba(0,0,0,0.62);color:#fff;border-radius:8px;padding:4px 12px 5px 10px;font-size:12px;font-weight:600;white-space:nowrap;text-align:center;line-height:1.5;pointer-events:none;box-shadow:0 1px 4px rgba(0,0,0,0.3);font-family:inherit;transform:translate(-50%,-50%);display:inline-block">${safeLabel}${areaText ? `<br/><span style="display:block;font-size:10px;font-weight:400;opacity:0.85;white-space:nowrap">${areaText}</span>` : ""}</div>`;
}

/** Update an existing Leaflet divIcon without interpolating persisted values into HTML. */
export function updateCenterLabelContent(element: Element | null | undefined, label: unknown, areaSqM: number): void {
  const root = element?.querySelector("div");
  if (!root || typeof document === "undefined") return;
  root.replaceChildren(document.createTextNode(String(label ?? "")));
  const areaText = formatMapAreaLabel(areaSqM);
  if (!areaText) return;
  root.append(document.createElement("br"));
  const area = document.createElement("span");
  area.style.display = "block";
  area.style.fontSize = "10px";
  area.style.fontWeight = "400";
  area.style.opacity = "0.85";
  area.style.whiteSpace = "nowrap";
  area.textContent = areaText;
  root.append(area);
}
